var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIsometric4 = function SvgIsometric4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1354 864"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4346F7",
    d: "M1134 0 220 766H0v98h220l914-766h220V0z"
  })));
};
export default SvgIsometric4;